import { gql } from 'urql';

const SubmitPayOverTimeLoanDisbursement = gql`
  mutation SubmitPayOverTimeLoanDisbursement(
    $idempotencyId: ID!
    $input: SubmitPayOverTimeLoanDisbursementInput!
  ) {
    submitPayOverTimeLoanDisbursement(
      idempotencyId: $idempotencyId
      input: $input
    ) {
      __typename
      ... on SubmitPayOverTimeLoanDisbursementSuccess {
        disbursementId
      }
      ... on SubmitPayOverTimeLoanDisbursementError {
        code
        title
        message
      }
    }
  }
`;

export default SubmitPayOverTimeLoanDisbursement;
